// extracted by mini-css-extract-plugin
export default {"container":"BoldButton-module__container__lM-Nr","primary":"BoldButton-module__primary__P8sH7","label":"BoldButton-module__label__1g4qs"};